import React from 'react';
import clsx from 'clsx';

interface CapabilitySearchInputProps {
  id?: string;
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  className?: string;
}

export function CapabilitySearchInput({
  id = 'capabilities-search',
  value,
  onChange,
  placeholder = 'Buscar por tipo ou tecnologia',
  className,
}: CapabilitySearchInputProps) {
  return (
    <div className={clsx('w-full', className)}>
      <label htmlFor={id} className="sr-only">
        Buscar capacidades
      </label>
      <input
        id={id}
        type="search"
        value={value}
        onChange={(event) => onChange(event.target.value)}
        placeholder={placeholder}
        className="w-full rounded-md border border-gray-300 px-3 py-2 text-sm text-gray-900 placeholder:text-gray-400 focus:border-indigo-500 focus:outline-none focus:ring-1 focus:ring-indigo-500"
      />
    </div>
  );
}

